// extracted by mini-css-extract-plugin
export default {"networks":"SocialNetworksLoginOrSignup_networks__s+gmG","networks__item":"SocialNetworksLoginOrSignup_networks__item__2ZYrU"};